import { VehicleResponse } from '../../app/features/connect/domain/vehicle.model';
import { VehicleStatus } from '../../app/features/connect/infrastructure/enums/vehicle-status.enum';

export const VEHICLES_RESPONSE: VehicleResponse = {
    vehicle_id: '123',
    cve_app_id: '123',
    redirect_uri: 'https://the.redirect.uri',
    status: VehicleStatus.DRAFT,
    vin: '1234567890',
    brand: 'TESLA',
    model: 'Q5 SPORTBACK',
    year: 2023,
};
